var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('p',[_c('small',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.$t('dashboard.total-submitter')))])]),_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }